import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dodao-ui/dodao-ui/academy-ui/src/app/guides/view/[...guideIdAndStep]/GuideInformation.tsx");
